module.exports = __webpack_public_path__ + "media/images/hero/glyph-f1-c7d23999474f30f0d5b317939b33ae31.svg";